export const MODULE_NAME = 'lk-mun-meh-form-review-readonly'

export const LK_MUN_MEH_FORM_HOST_VIEW_ROUTES = {
  LAYOUT: MODULE_NAME,
  FORM: `${MODULE_NAME}.review.form`,
  ANY_LEVEL: `${MODULE_NAME}.form.level`,
} as const
